import { DropdownWrapper } from '@anm/components/Dropdown';
import { CloseModalButtonWrapper } from '@anm/components/modals/CardModal';
import { grayFilter, media, stretchBlock } from '@anm/styles/helpers';
import styled, { createGlobalStyle } from 'styled-components';

import VideoRatioItem, {
  RatioContentWrapper
} from '../VideoRatioList/RatioItem/Wrapper';
import { RatioList } from '../VideoRatioList/Wrapper';

export const VIEW_MAX_WIDTH = 766;

const wrapperOnMobile = media.phone`
  max-width: 100%;
  overflow-y: auto;
  pointer-events: all;
`;

const closeButtonMobileStyles = media.phone`
  ${CloseModalButtonWrapper} {
    padding: 17px!important;
    button {
      ${grayFilter};
    }
  }
`;

export const CloseButtonOverrideStyles = createGlobalStyle`
  ${closeButtonMobileStyles};
`;

const Wrapper = styled.div`
  pointer-events: none;
  ${stretchBlock};
  z-index: 1;
  position: relative;
  max-width: ${VIEW_MAX_WIDTH}px;
  ${wrapperOnMobile};
  ${RatioList} {
    margin: 20px 50px 30px;
  }
  ${VideoRatioItem} {
    margin: 0;
    margin-top: 10px;
    border-bottom: 1px solid #919eaa;
  }
  ${RatioContentWrapper} {
    margin: 0 0 -1px;
    flex-direction: row;
    padding: 0 10px 13px;
    img {
      margin-right: 10px;
    }
  }
  ${DropdownWrapper} {
    right: 0;
    top: 45px;
    width: 40px;
    z-index: 130;
    height: 40px;
    position: absolute;
    background: rgba(41, 42, 43, 0.1) !important;
    &:after {
      filter: brightness(170%);
    }
  }
`;

export default Wrapper;
